import React, { useEffect, useState } from "react";
import _ from "lodash";



export default function CommonModal({ renderForm, onSubmit, handleClose, title }: any) {

	return (
		<>

			<div className="absolute fixed inset-0 flex justify-center items-center modal-overlay">
				<div className="my-2 mx-auto w-full max-w-[90vw] lg:max-w-[1100px] ">
					<div className="rounded-lg shadow-lg flex flex-col w-[1100px] bg-white  h-auto p-4 overflow-auto bg-scroll">
						<div className="flex items-start justify-between w-full border-b p-2">
							<div className="flex w-full flex-col items-start justify-between text-lg" >
								{title}
							</div>
							<div className="cursor-pointer mx-1">
								<svg onClick={() => handleClose()} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-x-circle"><circle cx="12" cy="12" r="10" /><path d="m15 9-6 6" /><path d="m9 9 6 6" /></svg>
							</div>
						</div>
						<div className="w-full flex flex-col p-1 ">
							{renderForm()}
						</div>
						<div className="w-full flex flex-row p-1 ">
							<div className="w-1/4">

							</div>
							<div className="w-3/4">
								<div className="flex flex-row justify-end items-center space-x-2">

									<button onClick={onSubmit} type="submit" className="border-x border-y bg-primary text-light px-2 py-1 text-sm font-light">
										Save
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div >

		</>
	);
}